import React from 'react'
import MobHome from './Mobile'
import { deviceDetect } from 'react-device-detect'
import PatientDesktop from '../Desktop/PatientDesktop'

// Always Render this component first
// Main wrapper for controls

const PatDashboardWrapper = () => {
  if (deviceDetect().isMobile) return <MobHome />
  else return <PatientDesktop />
}

export default PatDashboardWrapper
